import { IMAGES } from "@/lib/content";
import { Reveal } from "./Reveal";

const S = { fill: "none", stroke: "#a8531f", strokeWidth: 1.5 };

const WAYS = [
  {
    title: "Marriage coaching",
    text: "Sessions with couples who've worn the life.",
    icon: (
      <>
        <circle cx="15" cy="20" r="10" {...S} />
        <circle cx="25" cy="20" r="10" {...S} stroke="#143f47" />
      </>
    ),
  },
  { title: "Weekend retreats or workshops", text: "Time apart from orders, together.", icon: <path d="M4 32l12-20 8 12 4-6 8 14z" {...S} /> },
  { title: "Free resources and community", text: "Guides, groups and friends for every season.", icon: <path d="M8 10h24v20H8zM20 10v20" {...S} /> },
  { title: "Faith-based ministry", text: "Prayer, scripture and spiritual growth.", icon: <path d="M20 4v32M10 14h20" {...S} /> },
];

export const Ways = () => (
  <section id="ways" className="bg-paper text-pine py-24 md:py-32 scroll-mt-20" data-testid="ways-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_1.4fr] gap-12">
      <Reveal className="min-w-0">
        <h2 className="dp">Ways we walk <em>with you</em></h2>
        <figure className="mt-8 relative aspect-[3/4] overflow-hidden bg-mist-2">
          <img src={IMAGES.retreat} alt="Couples gathered at a weekend retreat" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
          <figcaption className="absolute bottom-5 left-5 lb bg-paper/90 text-moss px-3 py-1.5 rounded-full">Weekend retreat</figcaption>
        </figure>
      </Reveal>
      <ul className="min-w-0 divide-y divide-pine/15 self-center">
        {WAYS.map((w, i) => (
          <Reveal as="li" key={w.title} delay={i * 90} className="py-8 flex gap-6 group" data-testid={`way-item-${i}`}>
            <svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true" className="shrink-0 transition-transform duration-500 group-hover:rotate-12">
              {w.icon}
            </svg>
            <div>
              <h3 className="dp text-3xl">{w.title}</h3>
              <p className="mt-1 text-moss">{w.text}</p>
            </div>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
